import { env } from '@/env'
import { api } from '@/services/fintalk/api'

export interface CreateDashboardResponse {
  dashboard_id: string
  name: string
  bot_id: string
  external_dashboard_id: string
  token: string
}

export interface CreateDashboardParams {
  botId: string
  name: string
  externalDashboardId: string
  applyBotFilter: boolean
  defaultDashboard: boolean
}

export async function createDashboard({
  botId,
  name,
  externalDashboardId,
  applyBotFilter,
  defaultDashboard,
}: CreateDashboardParams): Promise<CreateDashboardResponse> {
  const resp = await api.post<CreateDashboardResponse>(
    env.VITE_FINTALK_BACKOFFICE_URL,
    `/bot/${botId}/dashboard`,
    {
      body: {
        name,
        external_dashboard_id: externalDashboardId,
        apply_bot_filter: applyBotFilter,
        default_dashboard: defaultDashboard,
      },
    },
  )

  return resp.body
}
